import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import Txt from '../../../inputs/textInput.js';
import Lbl from '../../../inputs/label.js';
import objectAssign from 'object-assign';
import { updateWaitingAreaNotifyRoomParticipantsForm } from '../../../../actions/waitingArea';
import { ValidMe } from '../../../../businessLogic/validation.js';

export default function CenterPanelNotifyRoomParticipant(props) {
  const dispatch = useDispatch();
  const [charsLeft, setCharsLeft] = useState(200);
  const [maxChars, setMaxChars] = useState(200);

  const notifyMessageChange = (value) => {
    value = value.substr(0, 200);
    dispatch(updateWaitingAreaNotifyRoomParticipantsForm(value));
    setCharsLeft(maxChars - value.length);
  };

  // Remove the space after caller's name is it has, for better UI display
  let callerName = props.participantRoomData.mainParticipant.name;
  if (/ $/.test(callerName)) {
    callerName = callerName.slice(0, -1);
  }
  return (
    <div className="ui form mrbs">
      <div>
        <div>
          <div className="title-sms color-info bold">{APP.LANGUAGE.NotifyCaller.TextAreaTitle}</div>
          <ValidMe validmefor="required" group="notifyRoomParticipantForm" fieldClasses="mrtxxs">
            <Txt
              textArea
              rows="7"
              classes="textarea minHeightTextareaMedium"
              tabIndex="1"
              noTitle
              fieldClasses="ui htxl input textarea mrtnull"
              titlePlaceholder=" "
              value={props.notifyRoomParticipants.message}
              onChange={notifyMessageChange}
              notRenderPlaceholderAsTitle={true}
            />
          </ValidMe>
        </div>
        <div className="wa-charsRight-new pdtnull mrtnull mrbm">
          <span>{APP.LANGUAGE.NotifyCaller.CharactersRemaining + charsLeft}</span>
        </div>
        <div className="clear-both" />
        <div className="title-sms color-info">
          {APP.LANGUAGE.NotifyCaller.Caption.replace('##caller##', callerName)}
        </div>
      </div>
    </div>
  );
}
